import { render } from "./ApartmentsTable.vue?vue&type=template&id=48c96cad&scoped=true"
import script from "./ApartmentsTable.vue?vue&type=script&lang=js"
export * from "./ApartmentsTable.vue?vue&type=script&lang=js"

import "./ApartmentsTable.vue?vue&type=style&index=0&id=48c96cad&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c96cad"]])

export default __exports__